import { IDataSource, ISearchPayload } from "@dataone/lib";
import { createContext, ReactNode, useContext, useState } from "react";

interface ContextType {
  showResponse: boolean;
  response: Partial<ISearchPayload>;
  selectedDB: IDataSource | null;
  searchMessageError: string;
  searchSuggestionsError: string[];
  setSearchMessageError: React.Dispatch<React.SetStateAction<string>>;
  setSearchSuggestionsError: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedDB: React.Dispatch<React.SetStateAction<IDataSource | null>>;
  setResponse: React.Dispatch<React.SetStateAction<Partial<ISearchPayload>>>;
  setShowResponse: React.Dispatch<React.SetStateAction<boolean>>;
}

const SmartSearchContext = createContext<ContextType>({
  showResponse: false,
  response: {},
  selectedDB: null,
  searchMessageError: "",
  searchSuggestionsError: [],
  setSearchMessageError: () => {},
  setSearchSuggestionsError: () => {},
  setSelectedDB: () => {},
  setShowResponse: () => {},
  setResponse: () => {},
});

export const SmartSearchProvider = ({ children }: { children: ReactNode }) => {
  const [showResponse, setShowResponse] = useState(false);
  const [response, setResponse] = useState<Partial<ISearchPayload>>({
    id: undefined,
    chartType: undefined,
    columnName: undefined,
    rows: undefined,
    hasLegend: undefined,
    colors: undefined,
    title: undefined,
    titleBold: undefined,
    titleColor: undefined,
    titleUnderline: undefined,
    titleItalic: undefined,
    subTitle: undefined,
    subTitleBold: undefined,
    subTitleColor: undefined,
    subTitleUnderline: undefined,
    subTitleItalic: undefined,
    data: undefined,
    summary: undefined,
    lineFillColor: undefined,
    lineChartType: undefined,
    target: undefined,
    targetValue: undefined,
    underTargetColors: undefined,
    stackedBar: undefined,
    barRowLine: undefined,
    barRowLineColor: undefined,
    donut: undefined,
    donutLabel: undefined,
  });
  const [selectedDB, setSelectedDB] = useState<IDataSource | null>(null);
  const [searchMessageError, setSearchMessageError] = useState("");
  const [searchSuggestionsError, setSearchSuggestionsError] = useState<
    string[]
  >([]);

  return (
    <SmartSearchContext.Provider
      value={{
        showResponse,
        response,
        selectedDB,
        searchSuggestionsError,
        searchMessageError,
        setSearchMessageError,
        setSearchSuggestionsError,
        setSelectedDB,
        setResponse,
        setShowResponse,
      }}
    >
      {children}
    </SmartSearchContext.Provider>
  );
};

export const useSmartSearch = () => useContext(SmartSearchContext);
